<template>
  <div class="requirePage">
    <step :active="2"></step>
    
    <!-- 采购需求表单 -->
    <div class="formContainer">
      <div class="formHeader">
        <h3 class="favoTit">请填写采购需求清单</h3>
      </div>
      <van-form @submit="onSubmitS">
        <van-cell-group inset>
          <van-field
            v-model="newForm.requirename"
            type="textarea"
            name="requirename"
            label="产品名称或更多要求"
            placeholder="请填写您需要采购的产品名称和要求，越详细越容易精准匹配契合的供应商"
            :rules="newRule.requirename"
            required
            :autosize="{ minHeight: 100, maxHeight: 200 }"
            class="textarea-field"
            label-align="top"
          />
          <van-field
            class="uploadFile"
            name="requirepic"
            label="需求图片/视频"
            placeholder="点击上传图片/视频"
          >
            <template #input>
              <van-uploader
                v-model="newForm.requirepic"
                :before-read="beforeRead"
                :after-read="afterRead"
                :max-count="1"
                accept="image/*,video/*"
                upload-text="选择文件"
              />
            </template>
          </van-field>
        </van-cell-group>
        <div style="margin: 16px">
          <van-button round block type="primary" native-type="submit" :color="btnColor">
            提交
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import api from '@/api'
import { useStore } from 'vuex'
import step from '@/components/step.vue'
import { showFailToast } from 'vant'
import { useRouter } from 'vue-router'

const btnColor = ref(
  'linear-gradient( 90deg, #091be1 0%, #0169d8 70%,  #01a9ed 100%)'
)

const store = useStore()
const router = useRouter()
const ExhCode = computed(() => store.state.ExhCode)
const VisitorID = computed(() => store.state.VisitorID)

// 表单数据
const newForm = ref({
  requirename: '',
  requirepic: []
})
const newRule = ref({
  requirename: [
    { required: true, message: '请填写您需要采购的产品名称和要求' }
  ]
})

const beforeRead = (file) => {
  const isImage = /image\/(jpeg|png|jpg)/.test(file.type)
  const isVideo = /video\/(mp4|mov|avi)/.test(file.type)
  if (!isImage && !isVideo) {
    showFailToast('请上传图片或视频文件')
    return false
  }
  if (file.size > 5 * 1024 * 1024) {
    showFailToast('文件大小不能超过5MB')
    return false
  }
  return true
}

const afterRead = async (file) => {
  console.log('上传文件:', file.file)
  const formData = new FormData()
  formData.append('file', file.file)
  const res = await api.fileUploadApi(formData)
  if (res.code === 200) {
    newForm.value.requirepic = [{ url: res.data.imageUrl }]
  }
}

const onSubmitS = async () => {
  const { requirename, requirepic } = newForm.value
  const params = {
    requirename,
    requirepic: requirepic && requirepic.length > 0 ? requirepic[0].url : '',
    visitorid: VisitorID.value,
    ExhCode: ExhCode.value
  }
  console.log(JSON.stringify(params), 'kkkkk')
  const res = await api.saveSApi(params)
  if (res.code === 200) {
    // 跳转到商家选择页面
    router.push({ path: '/favoSelect' })
  }
}

onMounted(() => {
  // 如果没有 VisitorID，返回登录页
  if (!VisitorID.value) {
    router.push({ path: '/login' })
  }
})
</script>

<style lang="less" scoped>
.requirePage {
  background: #f6f6f6;
  min-height: 100vh;
  padding-bottom: 20px;
}

.formContainer {
  background: #fff;
  width: 92%;
  margin: 20px auto;
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0px 0px 5px #cecece;

  .formHeader {
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    padding: 10px;
    margin-bottom: 10px;
  }

  .favoTit {
    font-size: 1em;
    padding: 3vw 0;
    text-align: left;
    text-indent: 1em;
    color: #481425;
  }
}

.uploadFile {
  :deep(.van-field__body) {
    border: 0;
    height: auto;
  }
}

.textarea-field {
  padding-bottom: 12px !important;

  :deep(.van-field__body) {
    border: none !important;
    box-shadow: none !important;
    height: auto !important;
  }

  :deep(textarea) {
    border: 1px solid #999999 !important;
    border-radius: 4px !important;
    padding: 8px 12px !important;
    margin-top: 8px !important;
  }

  :deep(.van-cell::after) {
    display: none !important;
  }

  :deep(.van-field__control::after) {
    display: none !important;
  }
}
</style>
